<template>
  <div class="at-toast-container">
    <Transition name="slide">
      <div
        class="at-toast-content slide-down"
        :style="{ color: textColor || '', background: bgColor || '' }"
      >
        <div>{{ title }}</div>
        <div class="flex items-center text-xs mt-2">
          <div v-if="roleName">{{ roleName }}</div>
          <div class="h-[12px] w-[1px] bg-[#fff] mx-1"></div>
          <div v-if="roleId">{{ roleId }}</div>
          <div v-if="serverName" class="h-[12px] w-[1px] bg-[#fff] mx-1"></div>
          <div v-if="serverName">{{ serverName }}</div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script lang="ts">
export default {
  name: 'AtToast'
}
</script>
<script setup lang="ts">
defineProps<{
  roleName?: string
  serverName?: string
  roleId?: string
  title: string
  textColor?: string
  bgColor?: string
}>()
</script>

<style scoped lang="less">
.at-toast-container {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  width: 100%;

  .at-toast-content {
    max-width: 90%;
    border-radius: 10px;
    background: var(--role-bar-bg-color);
    padding: 8px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    text-align: center;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.3s;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-50px);
  opacity: 0.3;
}

.slide-down {
  animation: slide-down 300ms ease;
}

@keyframes slide-down {
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
